<template>
  <div>
    <div v-for="post in posts" :key="post.id">
      <h3>{{ post.title }}</h3>
      {{ post.body }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'userPostsList',

  props: {
    posts: { type: Array }
  }
}
</script>
